
const breakpoints = {
  up_xs: '@media (min-width: 480px)',
  up_sm: '@media (min-width: 576px)',
  up_md: '@media (min-width: 768px)',
  up_lg: '@media (min-width: 992px)',
  up_xl: '@media (min-width: 1200px)',
  up_xxl: '@media (min-width: 1400px)',
  down_xs: '@media (max-width: 480px)',
  down_sm: '@media (max-width: 575px)',
  down_md: '@media (max-width: 767.98px)',
  down_lg: '@media (max-width: 991.98px)',
  down_xl: '@media (max-width: 1199.98px)',
  down_xxl: '@media maxn-width: 1399.98px)',
  highres: '@media screen and (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)',
  pad_sm: '@media all and (max-width: 540px) and (max-height: 720px) and (orientation:portrait)',
  pad: '@media all and (max-width: 768px) and (max-height: 1024px) and (orientation:portrait)',
  pad_md: '@media all and (max-width: 912px) and (max-height: 1368px) and (orientation:portrait)',
  pad_pro: '@media all and (max-width: 1024px) and (max-height: 1366px) and (orientation:portrait)'
    
}
const colors = {
  defaultBtn: '#000000',
  primary: '#2fb2c0',
  success: '#2c7d57',
  info: '#03b0c0',
  warning: '#FF5C5A',
  danger: '#FC3D1C',
  secondary: '#293441',
  background: '#F4F8FD',
  pink: '#ee577f',
  orange: '#ff7600',
  black: '#000000',
  white: '#ffffff',
  darker: '#232323',
  dark: '#2c3542',
  gray: '#6c757d',
  grayLight: '#979797',
}

const gutters = {
  xs: '5px',
  sm: '10px',
  md: '15px',
  lg: '20px',
  xl: '30px'
}
const containerMaxWidths = {
  xs: '480px',
  sm: '540px',
  md: '720px',
  lg: '960px',
  xl: '1200px',
  xxl: '1320px'
}
const linkState = {
  hover: '&:hover, &:focus',
  active: '&:hover, &:focus, &:active, &.active'
}
const radius = {
  none: '0px',
  xs: '3px',
  sm: '4px',
  md: '9px',
  lg: '12px',
  xl: '24px',
  pill: '50px',
  form: '4px',
}

const fontFamily = {
  Roman: `'Noto Sans', sans-serif`,
  Currency: `'Open Sans Condensed', sans-serif`,
  Handwriting: `'Lobster', cursive`,
  SansSerif: `"Helvetica Neue","Nimbus Sans", "Noto Sans TC", "Segoe UI", Roboto, "Microsoft JhengHei", "Microsoft YaHei", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
  Noto: `"Noto Sans TC", "Segoe UI", Roboto, "Microsoft JhengHei", "Microsoft YaHei", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
  Base: `"Helvetica Neue","Nimbus Sans", "Noto Sans TC", "Segoe UI", Roboto, "Microsoft JhengHei", "Microsoft YaHei", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
}
export { breakpoints, linkState, colors, fontFamily }
